import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { useForm, useWatch } from 'react-hook-form'
import { z } from 'zod'

import BusinessFormField from '../../components/business-form-field'
import BusinessFormTitle from '../../components/business-form-title'
import { useBusinessCreateContext } from '../../context/business-create-context'
import { useBusinessCreateStore } from '../../store/business-create-store'

const LastNameSchema = z.object({
  lastName: z.string().min(1, { message: 'Last name is required' }),
})
type LastNameSchemaType = z.infer<typeof LastNameSchema>

export default function BusinessCreateLastNameStep() {
  const { setFormData, formData } = useBusinessCreateStore()
  const { handleNext, setFooterConfig } = useBusinessCreateContext()

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<LastNameSchemaType>({
    resolver: zodResolver(LastNameSchema),
    defaultValues: {
      lastName: formData.consumerLastName ?? '',
    },
  })

  const lastNameValue = useWatch({
    control,
    name: 'lastName',
  })

  const onSubmit = (data: LastNameSchemaType) => {
    setFormData({ ...formData, consumerLastName: data.lastName })
    handleNext()
  }

  useEffect(() => {
    const hasLastName = !!lastNameValue?.trim()
    setFooterConfig({
      buttonText: hasLastName ? 'Continue' : 'Skip',
      buttonVariant: hasLastName ? 'default' : 'ghost',
      primaryAction: hasLastName ? undefined : () => handleNext(),
    })
  }, [lastNameValue, handleNext, setFooterConfig])

  return (
    <div className="flex size-full flex-col items-center justify-center gap-4">
      <BusinessFormTitle>{`What's your client's last name?`}</BusinessFormTitle>
      <form id="business-create-form" onSubmit={handleSubmit(onSubmit)}>
        <BusinessFormField
          register={register}
          placeholder="Last Name"
          name="lastName"
          type="text"
          error={errors.lastName}
          autoFocus={true}
        />
      </form>
    </div>
  )
}
